import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@mantine/core/styles.css'
import '@mantine/dates/styles.css'
import '@mantine/notifications/styles.css'
import '@mantine/spotlight/styles.css'
import { createDsnSink } from './api/errorReporting'
import { App } from './app/providers'
import { getConfig } from './app/config'
import { registerReportSink } from './lib/reporter'

// Parse configuration before mounting. A misconfigured deploy fails loudly here
// (docs/spec/01 §6) rather than surfacing later as an undefined in a URL.
const config = getConfig()

/**
 * Wire error reporting once, at startup (06 §6, Q11).
 *
 * With no DSN — the local default — no sink is registered and `lib/reporter`
 * stays a no-op. A developer's stack traces are already on their screen, and
 * shipping local noise into the shared project would bury real incidents.
 */
if (config.errorDsn !== null) {
  registerReportSink(createDsnSink(config.errorDsn, { environment: config.env }))
}

const container = document.getElementById('root')
if (!container) throw new Error('#root not found in index.html')

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
